import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { GeneralService } from '@mpt-fo/common/core/services/general.service';
import {LocalStorageService} from '@mpt-fo/common/core/services/local-storage.service';
import {MobileDelegateService} from '@mpt-fo/common/core/services/mobile-delegate.service';
import {MobileWebViewService} from '@mpt-fo/common/core/services/mobile-web-view.service';
import { RouteTrackerService } from '@mpt-fo/common/core/services/route-tracker.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import { NeedHelpComponent } from '../../need-help.component';

@Component({
	selector: 'app-need-help-mobile',
	templateUrl: './need-help-mobile.component.html',
	styleUrls: ['./need-help-mobile.component.scss']
})
export class NeedHelpMobileComponent extends NeedHelpComponent implements OnInit {

	constructor(
		delegateService: MobileDelegateService,
		screenManagerService: ScreenManagerService,
		mobileService: MobileWebViewService,
		localStorage: LocalStorageService,
		public router: Router,
		public generalService: GeneralService,
		routeHistory: RouteTrackerService) {
		super(
			screenManagerService,
			delegateService,
			mobileService,
			localStorage,
			router,
			generalService,
			routeHistory);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}


}
